import React,{useState} from 'react'
import { salesforceSendFormNumber, upayPaymentGateway } from '../../actions/StudentAction'

const UpayGateway = ({paymentConfig,userDetail,selectedMethodFeeDetail}) => {
    const {id,form_num} = userDetail !==undefined && userDetail
    const {instData} = selectedMethodFeeDetail
    const [loading,setLoading] = useState(false)

     const masterCardHandle = () => {
        setLoading(true)
        const data = {
            student_id: id,
	        amount:parseFloat(instData?.amount).toFixed(2) ,
            gateway_id: paymentConfig.id,
	        cancel_url:`${process.env.REACT_APP_PUBLIC_URL}/student/dashboard`,
	        success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/upay-payment-successfull/${id}/${selectedMethodFeeDetail?.pay_type}/${instData?.installment_number}/` 
        }

        upayPaymentGateway(data).then((res) => {
            setLoading(true)
            if(res.status){
                setLoading(false)
                salesforceSendFormNumber({form_num:form_num,status:'payment_initiated'})
                window.location.href=res?.paymentURL
            }
        })
    }

  return (
    <div>
        {loading ? <button type="submit" disabled className="banktransfer_btn">
                <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                Processing ...</button> : 
                <>
           <button 
           onClick={masterCardHandle} 
           className='banktransfer_btn'>Pay With Upay</button>
           {/* <button className='banktransfer_btn'>Master Card</button> */}
        </>
        }
        </div>
  )
}

export default UpayGateway